import { Component, Inject, Mixins } from '@/vue-property-decorator'
import { EntryType } from '..'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { Icon } from '@/plugins/ant-design-vue/tsx-support'
import { _PlayEntryBase as PlayEntryBase } from './cssVar/playEntryBase'
import { _PlayEntryDefault as PlayEntryDefault } from './cssVar/playEntryDefault'
import { createSvgSprite } from '@/utils/business-utils/assets'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { PlayEntryBase, PlayEntryDefault }
export type PlayEntryCssVarManager = GetCssVarManager<PlayEntryBase>

/** 兜底背景 注意:有使用absolute定位,因此,父级组件必须要有relative才行. */
@Component<PlayEntry>({
  name: 'PlayEntry'
})
export default class PlayEntry extends Mixins<BaseCssVarInject<PlayEntryBase>>(
  BaseCssVarInject
) {
  /** 获得cssVar 默认样式 */
  public static getCssVarDefault = () => new PlayEntryDefault()

  @Inject('setEntryType')
  private setEntryType!: (entryType: EntryType) => void
  created(): void {
    this.setEntryType(EntryType.Play)
  }
  render() {
    return (
      <div
        class={{
          [style['play-entry']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <Icon.Tsx
          component={{
            functional: true,
            render() {
              return (
                <icon-sprite
                  class={style['play-icon']}
                  sprite={createSvgSprite('icon_play')}
                />
              )
            }
          }}
        />
      </div>
    )
  }
}
